import React, { useState } from "react";
import styles from "./Input.module.scss";
import { FiEye, FiEyeOff } from "react-icons/fi";

export default function Input({
  disabled = false,
  id = "",
  type = "text",
  placeholder = "",
  onChange = () => console.log("Falta clg en Input.jsx"),
  onBlur = undefined,
  className = "",
  readOnly = false,
  value = "",
  name,
  min = undefined,
  max = undefined,
    step=undefined,
  accept,
  icon = null,
  title = null,
  label = null,
  style,
  maxLength = null,
  error = "",
  helperText = "",
  prefix = null,
  suffix = null,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    let val = e.target.value;

    if (type === "date" && val) {
      const [yyyy, mm, dd] = val.split("-");
      if (yyyy?.length > 4) {
        val = `${yyyy.slice(0, 4)}-${mm || ""}-${dd || ""}`;
        e.target.value = val;
      }
    }

    onChange(e);
  };

  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;

  return (
    <div className={styles.inputWrapper}>
      {label ? (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      ) : (
        title && <p className={styles.title}>{title}</p>
      )}
      <div className={styles.inputContainer}>

        {prefix && <span className={styles.inputPrefix}>{prefix}</span>}
        <input
          id={id}
          type={inputType}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={disabled}
          readOnly={readOnly}
          className={`${styles.inputCustom} ${error ? styles.inputError : ""
            } ${className}`}
          name={name}
          step={step}
          min={min}
          max={max}
          accept={accept}
          style={style}
          maxLength={maxLength}
        />
        {suffix && <span className={styles.inputSuffix}>{suffix}</span>}
        {icon && <span className={styles.inputIcon}>{icon}</span>}

      </div>
      {isPassword && (
        <span
          className={styles.inputIcon}
          onClick={() => setShowPassword((prev) => !prev)}
          style={{ cursor: "pointer", pointerEvents: "auto" }}
          aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
          role="button"
        >
          {showPassword ? <FiEyeOff /> : <FiEye />}
        </span>
      )}

      {!!error && <small className={styles.errorText}>{error}</small>}
      {!error && !!helperText && (
        <small className={styles.helperText}>{helperText}</small>
      )}
    </div>
  );
}